// extracted by mini-css-extract-plugin
export default {"soundToggle":"sound__soundToggle__xTbql","muted":"sound__muted__CKFOL"};